import getSchemaName from "../../tiny-functions/getSchemaName";

const ADD_SCHEMA = "ADD_SCHEMA";
const DROP_SCHEMA = "DROP_SCHEMA";

export const addSchema = (jsonResponse, path) => {
  if (jsonResponse.schema == null)
    throw new Error("Schema unavaiable for addschema action.");

  const name = getSchemaName(path);
  let action = {
    type: ADD_SCHEMA,
    name,
    pkName: jsonResponse.pk,
    schema: jsonResponse.schema,
  };

  return action;
};

export const dropSchema = () => {
  let action = {
    type: DROP_SCHEMA,
  };

  return action;
};
